import SpinnerWrapper from './SpinnerWrapper';

export default SpinnerWrapper;
